import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import {Provider} from "react-redux";
import store from "./store/store";
import {AppProvider} from "./context/AppContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <AppProvider>
                <App/>
            </AppProvider>
        </Provider>
    </React.StrictMode>
);
